import axios from '@/apis/axios';

class ShareDrive
{
    static async all()
    {
        const response = await axios.get('/api/share-drives');
        
        return response.data.data;
    }

    static async getAllCompaniesOfCurrentShareDrive($shareDrive)
    {
        const response = await axios.get(`/api/share-drives/${$shareDrive.id}/all-companies`);
        
        return response.data.data;
    }
}

export default ShareDrive;